import { Model } from 'app/model/backendmodel';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { Named, Owned } from 'app/model/base/named';
import { GoogleCloudStorageLocation } from 'app/model/dataset/location/google-cloud-storage.location';
import { FileLocationAdapter } from './file-location.adapter';
import { IModel } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(GoogleCloudStorageLocation)
})
export class GoogleCloudStorageLocationAdapter extends FileLocationAdapter<
    GoogleCloudStorageLocation,
    Model.DatasetLocation
> {
    public _toResource(store: GoogleCloudStorageLocation): Model.GoogleCloudStorageLocation {
        const resource: Model.GoogleCloudStorageLocation = {
            type: this.model().name,
            bucketName: ValueAdapter.toResource(store, GoogleCloudStorageLocation.CONTAINER) || undefined,
            folderPath: ValueAdapter.toResource(store, GoogleCloudStorageLocation.FOLDER_PATH) || undefined,
            fileName: ValueAdapter.toResource(store, GoogleCloudStorageLocation.FILE_NAME) || undefined
        };
        return resource;
    }

    public _toModel(resource: Model.GoogleCloudStorageLocation, owner: Named): GoogleCloudStorageLocation {
        const model = Owned.create<GoogleCloudStorageLocation>(this.model(), owner);
        ValueAdapter.toModel(model, GoogleCloudStorageLocation.CONTAINER, resource.bucketName);
        ValueAdapter.toModel(model, GoogleCloudStorageLocation.FOLDER_PATH, resource.folderPath);
        ValueAdapter.toModel(model, GoogleCloudStorageLocation.FILE_NAME, resource.fileName);
        return model;
    }

    protected model(): IModel {
        return GoogleCloudStorageLocation.MODEL;
    }
}
